import { render, staticRenderFns } from "./lookups.vue?vue&type=template&id=db1d00a4&"
import script from "./lookups.vue?vue&type=script&lang=js&"
export * from "./lookups.vue?vue&type=script&lang=js&"
import style0 from "./lookups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports